import {priority} from '@priority-software/priority-proto-api/lib';
import {getConnection, getCurSession} from '../../../../../_shared/GWTBridge/invoke/bpm/bpmMain';
import {buildServerCall} from '../../../../../services/wcfService';
import {AlertGWTType, GWTMetaData} from './types';
import {handleBPMMessages} from '../utils/handlePermission';
import {DocumentFields} from './enum';
// import {bpmAlertToCoverLetter} from '../utils/coverLetterSerializer';

export const bpmOpenRule = async (alert: string) => {
    const methodName = 'BPMAlert';
    const reason = 'BPMAlert';
    const parameters = {session: [getCurSession()], alert: [alert]};

    const res = await buildServerCall(methodName, parameters, reason, true, getConnection);
    const data = ((res as any)?.BPM as BpmAlert[])[0];
    const alertData = data?.AlertValues?.[0];
    const isOK = await handleBPMMessages(data);

    if (!isOK) return null;
    const coverLetters = alertData.CoverLetters?.[0] || {};

    return {
        alert: new priority.netitems.form.Alert({
            AlertNumber: Number(alertData.alert),
            Document: Number(alertData.document) || null,
            DocumentFormat: Number(alertData.docformat) || null,
            Description: alertData.description,
            MessageType: Number(alertData.messagetype) || null,
            MailType: Number(alertData.mailtype) || null,
            Active: alertData.active === '1',
            WebHook: Number(alertData.webhook) || null,
            Messages: [
                {
                    Subject: alertData.engsubject,
                    Message: alertData.engmessage,
                    Language: 3
                },
                {Subject: alertData.subject, Message: alertData.message, Language: 1}
            ],
            RecipientUser: Number(alertData.recipuser)
                ? [Number(alertData.recipuser)].concat(
                      Object.values<{
                          recipuser: string;
                      }>(alertData.RecipUsers?.[0]?.Recipuser || {}).map(item =>
                          Number(item.recipuser)
                      ) || []
                  )
                : null,
            RecipientGroup: Number(alertData.recipgroup)
                ? [Number(alertData.recipgroup)].concat(
                      Object.values<{
                          recipgroup: string;
                      }>(alertData.RecipGroups?.[0]?.Recipgroup || {}).map(item =>
                          Number(item.recipgroup)
                      ) || []
                  )
                : null,
            RecipientField: Number(alertData.recipfield) || null,
            RecipientMail: alertData.recipemail
                ? [alertData.recipemail].concat(
                      Object.values<{
                          recipemail: string;
                      }>(alertData.RecipMails?.[0]?.Recipemail || {}).map(
                          item => item.recipemail
                      ) || []
                  )
                : null,
            BPM: new priority.netitems.form.AlertBPM({
                TimeField: Number(alertData.timefield) || null,
                TimeUnit: Number(alertData.timeunit) || null,
                TimeValue: Number(alertData.time) || null,
                TimeStatus: null,
                ToStatus: Number(alertData.tostatus) || null,
                FromStatus: Number(alertData.fromstatus || null)
            }),
            Form: new priority.netitems.form.AlertForm({
                UpdateField: Number(alertData.updfield) || null,
                MultiComp: alertData.multicomp === '1'
            }),
            AlertConds: alertData.Conditions?.map(cond => {
                return new priority.netitems.form.AlertCondition({
                    CurrentValue: Number(cond.curvalue) || null,
                    ConditionOperator: Number(cond.op) || null,
                    ConditionField: Number(cond.field) || null,
                    ConditionValue: cond.value,
                    ConditionSecondValue: cond.secvalue
                });
            }),
            Pdf:
                alertData.pdf === DocumentFields.selectedPdf ||
                alertData.pdf === DocumentFields.selectedFormatAndPdf,
            ExtFile: alertData.extfiles === '1',
            WordTemplates:
                alertData.pdf === DocumentFields.selectedFormatAndPdf ||
                alertData.pdf === DocumentFields.selectedFormat,
            ConditionsOperator: alertData.conditionsOperator === '1',
            CoverLetters: Object.keys(coverLetters).map(key => {
                const isEnglish = key === 'coverletter2';

                return isEnglish
                    ? {
                          Subject: alertData.engsubject,
                          Message: coverLetters[key],
                          Language: 3
                      }
                    : {
                          Subject: alertData.subject,
                          Message: coverLetters[key],
                          Language: 1
                      };
            })
        })
    };
};

type BpmAlert = {
    AlertValues: AlertGWTType;
} & GWTMetaData;
